import { useEffect, useState } from 'react';

export const BREAKPOINT_SM = 576;
export const BREAKPOINT_MD = 768;
export const BREAKPOINT_LG = 992;
export const BREAKPOINT_XL = 1200;
export const BREAKPOINT_2XL = 1400;

const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });

  useEffect(() => {
    const handleResize = () =>
      setWindowSize({ width: window.innerWidth, height: window.innerHeight });

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return windowSize;
};

const useBreakpoint = () => {
  const [breakpoint, setBreakpoint] = useState('sm');
  const size = useWindowSize();

  useEffect(() => {
    if (size.width < BREAKPOINT_SM) {
      setBreakpoint('sm');
    } else if (size.width < BREAKPOINT_MD) {
      setBreakpoint('md');
    } else if (size.width < BREAKPOINT_LG) {
      setBreakpoint('lg');
    } else if (size.width < BREAKPOINT_XL) {
      setBreakpoint('xl');
    } else {
      setBreakpoint('2xl');
    }
  }, [size.width]);

  return {
    breakpoint,
    isMobile: breakpoint === 'sm' || breakpoint === 'md',
    isDesktop:
      breakpoint === 'lg' || breakpoint === 'xl' || breakpoint === '2xl',
  };
};

export { useBreakpoint, useWindowSize };
